import { Fragment, type Node } from '@tiptap/pm/model';
import type { EditorState } from '@tiptap/pm/state';
import { Plugin, PluginKey, TextSelection } from '@tiptap/pm/state';

import { Node_Type } from './../../ricos-schema/legacy/wix/rich_content/v1';
import { MAX_LIST_VISIBLE_INDENTATION, normalizeOffset } from './../../wix-rich-content-common';

import { getListItemsWithVisibleIndentation } from '../list-item/commands/commons';

export const createOffsetNormalizingTransactionPlugin = () => {
  return new Plugin({
    key: new PluginKey('normalize-offsets'),
    appendTransaction: (_, _oldState: EditorState, newState: EditorState) => {
      if (newState.doc === _oldState.doc && newState.selection === _oldState.selection) {
        return;
      }

      const tr = newState.tr;
      const listItemsWithVisualIndent = getListItemsWithVisibleIndentation(tr);

      const descendants: Node[] = [];
      let start: number | null = null;
      let end: number | null = null;

      listItemsWithVisualIndent.forEach(({ node, pos, visibleIndentation }) => {
        if (visibleIndentation < 0 && node.attrs.offset < 0) {
          tr.setNodeAttribute(
            pos,
            'offset',
            normalizeOffset(node.attrs.offset - visibleIndentation)
          );
        }
        if (visibleIndentation > MAX_LIST_VISIBLE_INDENTATION) {
          if (
            node.attrs.offset > 0 &&
            visibleIndentation - node.attrs.offset <= MAX_LIST_VISIBLE_INDENTATION
          ) {
            tr.setNodeAttribute(
              pos,
              'offset',
              normalizeOffset(node.attrs.offset - visibleIndentation + MAX_LIST_VISIBLE_INDENTATION)
            );
          } else {
            const listItemType = node.firstChild?.type;
            node.forEach((childNode: Node) => {
              childNode.forEach((grandChildNode: Node) => {
                if (
                  (grandChildNode.type.name === Node_Type.PARAGRAPH ||
                    grandChildNode.type.name === Node_Type.HEADING) &&
                  listItemType
                )
                  descendants.push(listItemType.create(null, grandChildNode));
              });
            });
            if (!start) {
              start = pos;
              end = pos + node.nodeSize;
            }
          }
        }
      });
      if (start && end) {
        const fragment = Fragment.from(descendants);
        const prevSelection = tr.selection;
        tr.delete(start, end)
          .insert(start + 1, fragment)
          .setSelection(
            TextSelection.between(
              tr.doc.resolve(prevSelection.from),
              tr.doc.resolve(prevSelection.to)
            )
          );
      }

      return tr;
    },
  });
};
